document.querySelector(".b-brand").addEventListener("click", e => {
  e.preventDefault();
});
